import { MinusCircleTwoTone, PlusCircleTwoTone } from '@ant-design/icons';
import { Button, Card, Form, Input, Modal, Switch, TimePicker, message } from 'antd';
import { SetStateAction, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { GlobalVariableContext } from '../../../../../../store/GlobalVariableContext/GlobalVariableContext';
import { authFetch } from '../../../../../../common/request/authFetch';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';

export const FestiveScheduleEdit = (props: {
	locationName: string, 
	ranges: any,
	festiveDate: any,
	onCancel: any,
	onFinish: any
}) => {
	
	dayjs.extend(customParseFormat);

	const [shiftForm] = Form.useForm();

	const [isOpen, setIsOpen] = useState(!props.ranges[0].closed);
	const {updateGlobalData, setUpdateGlobalData } = useContext(GlobalVariableContext)
	const { projectGroup } = useAuth();

	const { t } = useTranslation();

	const format = 'HH:mm';
	//const formatTZ = 'YYYY-MM-DDTHH:mm[Z]';	

	const initialValues = props.ranges.filter((period: any) => !period.closed).map((period: any) => 
	([ dayjs(`${period.openTimeHour}:${period.openTimeMinute}`, format), dayjs(`${period.closeTimeHour}:${period.closeTimeMinute}`, format)]
	));

	const submitEdit = async (values: any) => {
		
		// When open ranges are mandatory
		if (values.openCheckbox && values.festives?.length === 0) {
			return message.warning('Se necesita un rango horario');
		}

		//const timeRanges = values.festives && values.festives.map((timeRange: any) => ({openTime: timeRange[0].format(formatTZ), closeTime: timeRange[1].format(formatTZ)}));

		//
		const timeRanges = values.festives && values.festives.map((timeRange: any) => ({
			// .utc() convierte la hora de Barcelona a UTC restando las 2 horas correspondientes
			openTime: timeRange[0].utc().format(), 
			closeTime: timeRange[1].utc().format()
		}));

		const data = {
			field: 'ADD_SPECIAL_HOURS',
			specialHours: {
				timeRanges : timeRanges,
				open: values.openCheckbox,
				festiveDate: props.festiveDate
			},			
			//locationsNames: locationIds
		};

		try {
			await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/${props.locationName}`, { method: 'PATCH', data: data })
				.then((res) => {

					if (res) {
						message.success(t('view.forms.modal.single.success', { field: 'festivo' }), 3);
						props.onFinish();
						setUpdateGlobalData(!updateGlobalData);
					} else {
						message.error(t('view.forms.modal.single.error'), 3)
					}
				});

		} catch (error: any) {
			return message.error(error.message)
		}
	};

	return (

		<Form layout='vertical' form={shiftForm} onFinish={(values) => submitEdit(values)} initialValues={{openCheckbox: !props.ranges[0].closed, festives: initialValues}}>
			<>
			{
				<Form.Item name={'openCheckbox'} valuePropName="checked" style={{ width: '10%', marginBottom: '10px' }}>
					<Switch size='small' checkedChildren="Abierto" unCheckedChildren="Cerrado" defaultChecked={isOpen} onChange={(e) => {setIsOpen(e)}}/>
				</Form.Item>
			}
			
			{isOpen && 
				<Form.List name="festives">
					{(fields, { add, remove }) => {
						return (
						<Card style={{background:'GhostWhite'}}>						
							{
							fields.map((field, i) => (
								<div key={field.key}>
								{
									<div style={{ display: 'flex' }}>
										<Form.Item name={[i]} shouldUpdate>					
											<TimePicker.RangePicker  format={format} disabled={!isOpen} minuteStep={10}/>
										</Form.Item>												
										{
										fields.length > 0 && 
											<button
												style={{ width: '10%', height: '32px', backgroundColor: "transparent", border: "none", fontWeight: 600, padding: "0 1em", cursor: "pointer" }}
												onClick={() => remove(field.name)} >
												X
											</button>
										}
									</div>
								}
								</div>
							))
							}
							{(fields.length <= 10) &&
							<button type='button' style={{ paddingBottom: "1em", border: "none", backgroundColor: "transparent", color: "#2781DD", fontWeight: 600, cursor: "pointer" }} onClick={() => add()}>
								+ Añadir Rango Horario
							</button>}
						</Card>
						)
					}}
				</Form.List>
			}						
			{		
				<Form.Item shouldUpdate style={{ marginTop: '15px' }}>
					{() => {
						return (
							<>
								<Button
									style={{ background: 'var(--primary)', color: 'white', marginLeft: '20px' }}
									onClick={
										() => {
											Modal.confirm({
												title: t('view.forms.modal.single.title'),
												okText: t('dictionary.confirm'),
												cancelText: t('dictionary.cancel'),
												onOk: shiftForm.submit
											});
										}
									}
								>
									{t('dictionary.save')}
								</Button>
								<Button
									style={{ background: 'white', color: 'dodgerblue', marginLeft: '20px', borderColor: 'dodgerblue' }}
									onClick={() => {
										shiftForm.resetFields();																						
										props.onCancel();
									}}
									type="primary">
									{t('dictionary.cancel')}
								</Button>
							</>
						)
					}}
				</Form.Item>
			}				
			</>		
		</Form>
	)
}